import { BookReqBody } from "@/app/clinic/[clinicSlug]/types";
import { get, post, qs } from "./base";
import { CancelPreviewResponse, RawAppointment } from "@/app/types/Appointment";
import { BlockTime } from "@/app/types/BlockTime";
import { ClinicRow } from "@/app/types/Clinic";
import { ClinicHours } from "@/app/types/ClinicHours";
import { ProviderRow } from "@/app/types/Provider";
import { Schedule } from "@/app/types/Schedule";

export const publicRoutes = {
  appointments: {
    post: () =>
      post<{ item: RawAppointment }, BookReqBody>(`/api/public/appointments`),
    cancel: () =>
      post<void, { token: string }>(`/api/public/appointments/cancel`),
    cancelPreview: (token: string) =>
      get<CancelPreviewResponse>(
        `/api/public/appointments/cancel?token=${token}`,
      ),
  },
  clinics: {
    getOne: (slug: string) =>
      get<{ item: ClinicRow }>(`/api/public/clinics/${slug}`),
  },
  clinicHours: {
    get: (clinicId: string) =>
      get<{ hours: ClinicHours[] }>(`/api/public/clinic-hours/${clinicId}`),
  },
  freeDays: {
    get: (typeProviderId: string, providerId: string, month: string) =>
      get<{ days: string[] }>(
        `/api/public/free-days?${qs({
          typeProviderId,
          providerId,
          month,
        })}`,
      ),
  },
  nextSlot: {
    get: (typeProviderId: string, providerId: string) =>
      get<{ next_slot_utc: string | null }>(
        `/api/public/next-slot?${qs({ typeProviderId, providerId })}`,
      ),
  },
  providers: {
    get: (clinicId: string, includeNextSlot?: boolean) =>
      get<{ items: ProviderRow[] }>(
        `/api/public/providers?${qs({ clinicId, includeNextSlot })}`,
      ),
  },
  schedules: {
    get: (providerId: string) =>
      get<{ items: Schedule[] }>(`/api/public/schedules?${qs({ providerId })}`),
  },
  slots: {
    get: (typeProviderId: string, date: string, providerId?: string) =>
      get<{ slots: string[] }>(
        `/api/public/slots?${qs({
          typeProviderId,
          date,
          providerId,
        })}`,
      ),
  },
  blockTimes: {
    get: (providerId: string, month: string) =>
      get<{ items: BlockTime[] }>(
        `/api/public/block-times?${qs({ providerId, month })}`,
      ),
  },
};
